import { noop } from '@ajaibid/utils';
import { FORM_OPTIONS } from './constants';

export const checkFormDisabled = ({ orderSide, accountType, disabledForms }) => {
  let key = '';
  switch (true) {
    case orderSide === 'BUY' && accountType === 'DAY_TRADING':
      key = 'DT_BUY_LIMIT';
      break;
    case orderSide === 'SELL' && accountType === 'DAY_TRADING':
      key = 'DT_SELL_LIMIT';
      break;
    case orderSide === 'BUY' && accountType === 'MARGIN_TRADING':
      key = 'MT_BUY_LIMIT';
      break;
    case orderSide === 'SELL' && accountType === 'MARGIN_TRADING':
      key = 'MT_SELL_LIMIT';
      break;
    default:
      break;
  }

  return {
    isDisabled: !!disabledForms[key],
    callback: disabledForms[key] ?? noop,
  };
};

export const checkAccountTypeHasOrderType = ({ newAccountType, currentOrderType }) => {
  const isNewAccountTypeHasOrderType = newAccountType?.orderTypes?.includes(currentOrderType?.key);
  const newOrderType = isNewAccountTypeHasOrderType ? currentOrderType : FORM_OPTIONS.ORDER_TYPE[0];
  return { newOrderType };
};

export const getMaxBuy = (formState, formKey) => {
  const accountType = formState?.[formKey.INPUT_ACCOUNT_TYPE]?.value;
  const keyMap = {
    REGULAR: formKey.CONST_MAX_BUY,
    DAY_TRADING: formKey.CONST_MAX_BUY_DT,
    MARGIN_TRADING: formKey.CONST_MAX_BUY_MT,
  };

  return formState?.[keyMap[accountType]] ?? 0;
};

export const getMaxSell = (formState, formKey) => {
  const accountType = formState?.[formKey.INPUT_ACCOUNT_TYPE]?.value;
  const keyMap = {
    REGULAR: formKey.CONST_MAX_SELL,
    DAY_TRADING: formKey.CONST_MAX_SELL_DT,
    MARGIN_TRADING: formKey.CONST_MAX_SELL_MT,
  };

  return formState?.[keyMap[accountType]] ?? 0;
};
